import Link from "next/link";
import React from "react";

import Styles from "./Terms.styles";
import { TermsProps as Props } from "./Terms.types";
import Footer from "components/global/Footer/Footer";
import GoBack from "components/global/GoBack/GoBack";
import Navbar from "components/global/Navbar/Navbar";
import ProfileNavigation from "components/global/ProfileNavigation/ProfileNavigation";
import CONSTANTS from "config/constants";
import useI18n from "hooks/useI18n";

import ChevronRightSVG from "../../../../public/assets/images/arrow-to-right-black.svg";

const { FEATURE_FLAGS } = CONSTANTS;
const { WITH_BOTTOM_SEARCH, WITH_BOTTOM_RESPONSIVE_BUTTONS } = FEATURE_FLAGS;

const Terms: React.FC<Props> = props => {
  const t = useI18n();

  return (
    <Styles
      className="Terms"
      withBottomSearch={WITH_BOTTOM_SEARCH}
      withBottomResponsiveButtons={WITH_BOTTOM_RESPONSIVE_BUTTONS}
    >
      <header className="Terms__header">
        <Navbar showBrand />
      </header>
      <main className="Terms__main">
        <ProfileNavigation className="Terms__profile-navigation" />
        <section className="Terms__content">
          <GoBack className="Terms__go-back" title="Atrás" />
          <div className="Terms__container">
            <h1 className="Terms__title">{t.terms.legalTerms}</h1>
            <Link href="/profile/terms/privacy" passHref>
              <div className="Terms__labels">
                <p className="Terms__labels-text">{t.terms.privacy}</p>
                <ChevronRightSVG />
              </div>
            </Link>
            <Link href="/profile/terms/legal" passHref>
              <div className="Terms__labels">
                <p className="Terms__labels-text">{t.terms.legalTerms}</p>
                <ChevronRightSVG />
              </div>
            </Link>
            <Link href="/profile/terms/data" passHref>
              <div className="Terms__labels">
                <p className="Terms__labels-text">{t.terms.data}</p>
                <ChevronRightSVG />
              </div>
            </Link>
          </div>
        </section>
      </main>
      <footer className="Terms__footer">
        <Footer />
      </footer>
    </Styles>
  );
};

Terms.defaultProps = {};

export default Terms;
